import { parseAsStringLiteral, useQueryStates } from 'nuqs';

export const QUESTION_STATUSES = ['DRAFT', 'PUBLISHED', 'DISABLED', 'UNPUBLISHED'] as const;
export type QuestionStatus = (typeof QUESTION_STATUSES)[number];

export default function useQBankStructureDashboardSearchParams() {
  const [{ status }, setQBankStructureDashboardSearchParams] = useQueryStates({
    status: parseAsStringLiteral<QuestionStatus>(QUESTION_STATUSES).withDefault('PUBLISHED'),
  });

  const changeStatus = (status: QuestionStatus) => {
    setQBankStructureDashboardSearchParams({ status });
  };

  return [{ status }, { changeStatus }] as const;
}
